import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "header bg-[#232e3c] p-3 flex items-center" }
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = { class: "ml-3" }
const _hoisted_4 = { class: "text-white font-medium" }
const _hoisted_5 = { class: "ml-auto flex gap-3" }
const _hoisted_6 = { class: "input-area bg-[#17212b] border-t border-[#232e3c] p-3 flex items-center absolute bottom-0 w-full" }

import { ArrowLeft, Search, MoreVertical, Paperclip, Mic } from 'lucide-vue-next'


export default /*@__PURE__*/_defineComponent({
  __name: 'TelegramChatSkeleton',
  props: {
  sender: {
    type: String,
    default: 'Bot'
  },
  class: {
    type: String,
    default: ''
  }
},
  setup(__props) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["telegram-preview bg-[#0e1621] overflow-hidden relative pb-[65px] h-full", __props.class])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(ArrowLeft), { class: "text-[#8a9aa9] mr-3 size-5" }),
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "avatar-container" }, [
          _createElementVNode("svg", {
            class: "avatar-svg",
            viewBox: "0 0 36 36"
          }, [
            _createElementVNode("circle", {
              class: "avatar-circle",
              cx: "18",
              cy: "18",
              r: "16"
            })
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h3", _hoisted_4, _toDisplayString(__props.sender || 'Bot'), 1),
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "status-text" }, [
            _createElementVNode("span", null, "conectando"),
            _createElementVNode("span", { class: "dot-animation" }, "."),
            _createElementVNode("span", {
              class: "dot-animation",
              style: {"animation-delay":"0.3s"}
            }, "."),
            _createElementVNode("span", {
              class: "dot-animation",
              style: {"animation-delay":"0.6s"}
            }, ".")
          ], -1))
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_unref(Search), { class: "text-[#8a9aa9] size-5" }),
        _createVNode(_unref(MoreVertical), { class: "text-[#8a9aa9] size-5" })
      ])
    ]),
    _cache[3] || (_cache[3] = _createStaticVNode("<div class=\"messages-container bg-[#0e1621] p-4 min-h-[350px] overflow-y-auto flex flex-col-reverse\" data-v-83896880><div class=\"central-animation\" data-v-83896880><div class=\"wave-container\" data-v-83896880><div class=\"wave-circle\" data-v-83896880></div><div class=\"wave wave-1\" data-v-83896880></div><div class=\"wave wave-2\" data-v-83896880></div><div class=\"wave wave-3\" data-v-83896880></div></div><div class=\"paper-plane-container\" data-v-83896880><div class=\"paper-plane\" data-v-83896880><div class=\"plane-body\" data-v-83896880></div><div class=\"plane-wing\" data-v-83896880></div></div><div class=\"plane-trail\" data-v-83896880></div></div><div class=\"loading-text\" data-v-83896880>Carregando conversa</div></div></div>", 1)),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_unref(Paperclip), { class: "text-[#8a9aa9] size-5 mr-3" }),
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "bg-[#232e3c] rounded-full flex-1 py-2 px-4 text-[#8a9aa9] relative overflow-hidden" }, [
        _createElementVNode("span", { class: "opacity-50" }, "Mensagem"),
        _createElementVNode("div", { class: "input-gradient" })
      ], -1)),
      _createVNode(_unref(Mic), { class: "text-[#8a9aa9] size-5 ml-3" })
    ])
  ], 2))
}
}

})